// ppd 在线客服
export default [
  {
    path: '/outServiceEvaluation',
    name: 'outServiceEvaluation',
    component: () =>
      import(
        /* webpackChunkName: "customer" */ '@/views/online-servicer/out-service-evaluation/OutServiceEvaluation.vue'
      ),
    meta: { title: '外包服务评价', keepAlive: true }
  },
  {
    path: '/outServiceOverall',
    name: 'outServiceOverall',
    component: () =>
      import(
        /* webpackChunkName: "customer" */ '@/views/online-servicer/out-service-overall/OutServiceOverall.vue'
      ),
    meta: { title: '外包服务指标', keepAlive: true }
  },
  {
    path: '/serviceProviderOrdinaryOrder',
    name: 'serviceProviderOrdinaryOrder',
    component: () =>
      import(
        /* webpackChunkName: "customer" */ '@/views/online-servicer/service-provider-order/ServiceProviderOrdinaryOrder.vue'
      ),
    meta: { title: '服务商普通工单', keepAlive: true }
  },
  {
    path: '/serviceProviderOrdinaryOrderView/:type/:id',
    name: 'serviceProviderOrdinaryOrderView',
    component: () =>
      import(
        /* webpackChunkName: "customer" */ '@views/online-servicer/service-provider-order/ServiceProviderOrdinaryOrderView.vue'
      ),
    meta: { title: '服务商普通工单查看', keepAlive: true }
  },
  {
    path: '/serviceProviderClaimOrder',
    name: 'serviceProviderClaimOrder',
    component: () =>
      import(
        /* webpackChunkName: "customer" */ '@views/online-servicer/service-provider-order/ServiceProviderClaimOrder.vue'
      ),
    meta: { title: '服务商理赔工单', keepAlive: true }
  },
  {
    path: '/serviceProviderClaimOrderView/:type/:id',
    name: 'serviceProviderClaimOrderView',
    component: () =>
      import(
        /* webpackChunkName: "customer" */ '@views/online-servicer/service-provider-order/ServiceProviderClaimOrderView.vue'
      ),
    meta: { title: '服务商理赔工单查看', keepAlive: true }
  },
  {
    path: '/customerServiceIncomingReport',
    name: 'customerServiceIncomingReport',
    component: () =>
      import(
        /* webpackChunkName: "customer" */ '@views/online-servicer/CustomerService/CustomerServiceIncomingManager'
      ),
    meta: { title: '外包客服进线', keepAlive: true }
  },
  {
    path: '/userIncomingInformation',
    name: 'userIncomingInformation',
    component: () =>
      import(
        /* webpackChunkName: "customer" */ '@views/online-servicer/user-incoming-information/UserIncomingInformation'
      ),
    meta: { title: '用户进线信息', keepAlive: true }
  },
  {
    path: '/serviceProvidersRepeatline',
    name: 'serviceProvidersRepeatline',
    component: () =>
      import(
        /* webpackChunkName: "customer" */ '@views/online-servicer/service-provider-order/ServiceProvidersRepeatline.vue'
      ),
    meta: { title: '服务商重复进线', keepAlive: true }
  },
  {
    path: '/problemRecord',
    name: 'problemRecord',
    component: () =>
      import(
        /* webpackChunkName: "customer" */ '@views/online-servicer/ProblemRecord/ProblemRecord'
      ),
    meta: { title: '服务商问题记录', keepAlive: true }
  },
  {
    path: '/problemRecordView/:id',
    name: 'problemRecordView',
    component: () =>
      import(
        /* webpackChunkName: "customer" */ '@views/online-servicer/ProblemRecord/ProblemRecordView'
      ),
    meta: { title: '查看', keepAlive: true }
  },
  {
    path: '/CustomerServiceCenter',
    name: 'CustomerServiceCenter',
    component: () =>
      import(
        /* webpackChunkName: "customer" */ '@views/customer-service-center/CustomerServiceCenter'
      ),
    meta: { title: '学习中心', keepAlive: true }
  },
  {
    path: '/agentAssistantIndicators',
    name: 'agentAssistantIndicators',
    component: () =>
      import(
        /* webpackChunkName: "netNumManage" */ '@views/agent-assistant-indicators/agentAssistantIndicators'
      ),
    meta: { title: '录单小助手', keepAlive: true }
  }
]
